import { ICrud } from "./common";
import { IUserData } from "./Users";

export enum EUserFlagType {
  PAYMENT_CONFIRMED = "payment_confirmed",
}

export interface IUserFlag extends ICrud {
  userId: string;
  user?: IUserData;
  type: EUserFlagType;
  data?: Record<string, string>;
}

export interface ICreateUserFlagDto {
  // userId: string;
  type: EUserFlagType;
}

export interface IGetMeUserFlagDto {
  // userId: string;
  type: EUserFlagType;
}
